// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"171":"7226c5cc46118415","331":"8254463fd52639a7","459":"579b44ec6c15070b","788":"5280dd087af2042b"}[chunkId] + ".css";
};